import RemuneracaoMedicaApi from './Services/RemuneracaoMedicaApi'
import RemuneracaoMedicaChatApi from './Services/RemuneracaoMedicaChatApi'

export default {
  RemuneracaoMedicaApi,
  RemuneracaoMedicaChatApi,
}
